import { flowRight } from 'lodash';
import withCurrentUser from './withCurrentUser';
import propMapper from './propMapper';
const mapperHoc = propMapper({
    currentUser: ({ personPasswordInfo }) => ({
        currentUserPasswordInfo: personPasswordInfo,
    }),
});
export default (...params) => flowRight(withCurrentUser(...params), mapperHoc);
